/**
 * 브라우저 CSS 기능 검사 — 인라인 style 은 @supports 로 감쌀 수 없어서 스크립트에서 가른다.
 *
 * 관제 보드(RK3568)의 WebView 는 Chromium 106 이라 `color-mix()`(111+) 를 모른다. 인라인 style 에 쓴
 * color-mix 는 선언이 통째로 버려져 **경보 화면의 등급 띠·긴급 타이머 배경이 사라졌다**(2026-09-30 감사).
 * CSS 파일 쪽은 tokens.css 의 정적 값 + @supports 로 이미 막았다 — 이것은 인라인 쪽 짝이다.
 */
export const SUPPORTS_COLOR_MIX: boolean = (() => {
  try {
    return typeof CSS !== "undefined" && typeof CSS.supports === "function"
      && CSS.supports("color", "color-mix(in oklab, red 10%, white)");
  } catch {
    return false;
  }
})();

/** color-mix 를 쓸 수 있으면 그 식을, 아니면 미리 정한 대체 색(보통 `-soft` 토큰)을 준다. */
export const mixOr = (mix: string, fallback: string): string => (SUPPORTS_COLOR_MIX ? mix : fallback);
